<template>
  <WtTile ancestor vertical>
    <WtTile parent :col="12">
      <WtTile child :col="4">
        <WtLabel is-label-element text="Map Builder" />
        <div class="level">
          <div class="level-left">
            <div class="level-item">
              <WtButton is-router-link :to="{ name: 'AdminSuperMapsBuilder' }">
                CREATE A NEW MAP
              </WtButton>
            </div>
          </div>
        </div>
      </WtTile>
    </WtTile>
  </WtTile>
</template>

<script>
import WtTile from "@@/WtTile/WtTile";
import WtButton from "@@/WtButton/WtButton";
import WtLabel from "@@/WtLabel/WtLabel";

export default {
  name: "AdminSuperMapsCenterSettings",

  components: { WtLabel, WtTile, WtButton }
};
</script>

<style lang="sass" scoped></style>
